<template>
  <!-- <v-navigation-drawer v-model="drawer" temporary scrim="true" location="right" class="pt-4 px-3" color="#111213"
    mobile-breakpoint="xs" :width="$vuetify.display.xs ? $vuetify.display.width : drawer ? '400px' : ''">
    <v-list nav width="100%" size="compact">
      <v-list-item class="mb-0 pb-0">
        <template v-slot:append>
          <v-btn icon :class="drawer ? 'btn-close-drawer' : ''" color="#F6F2E6" size="x-large"
            v-if="$vuetify.display.smAndDown" @click.stop="drawer = !drawer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
</v-list-item>

<v-list-subheader class="subheader">Navigation</v-list-subheader>

<v-list-item>
  <v-btn variant="tonal" :color="$vuetify.locale.current == 'en' ? '#CC8702' : '#9A9A9B'
          " class="drawer-langs pa-1" @click="changeLocale('en')">
    <v-row justify="center" class="ma-0" style="padding-top: 4px;">
      EN
    </v-row>
  </v-btn>
  <v-btn variant="tonal" :color="$vuetify.locale.current == 'ro' ? '#CC8702' : '#9A9A9B'
          " class="drawer-langs pa-1 mx-2" @click="changeLocale('ro')">
    <v-row justify="center" class="ma-0" style="padding-top: 4px;">
      RO
    </v-row>
  </v-btn>
  <v-btn variant="tonal" :color="$vuetify.locale.current == 'ru' ? '#CC8702' : '#9A9A9B'
          " class="drawer-langs pa-1" @click="changeLocale('ru')">
    <v-row justify="center" class="ma-0" style="padding-top: 4px;">
      RU
    </v-row>
  </v-btn>
</v-list-item>

<div class="px-2">
  <v-divider class="mt-3 mb-8 px-2"></v-divider>
</div>

<v-list-item value="home" @click="$router.push(GetPath('home'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.home") }}
  </v-list-item-title>
</v-list-item>
<v-list-item value="real_estate" @click="$router.push(GetPath('real-estate'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.real_estate") }}
  </v-list-item-title>
</v-list-item>
<v-list-item value="about" @click="$router.push(GetPath('about'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.about") }}
  </v-list-item-title>
</v-list-item>
<v-list-item value="learn" @click="$router.push(GetPath('learn'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.learn") }}
  </v-list-item-title>
</v-list-item>
<v-list-item value="partners" @click="$router.push(GetPath('partners'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.partners") }}
  </v-list-item-title>
</v-list-item>
<v-list-item value="contact" @click="$router.push(GetPath('contact'))">
  <v-list-item-title class="drawer-list-items">
    {{ t("$vuetify.header.contact") }}
  </v-list-item-title>
</v-list-item>

<v-list-subheader class="subheader mt-3">Social Media</v-list-subheader>

<div class="px-2">
  <v-divider class="mt-2 mb-4"></v-divider>
</div>

<v-row justify="space-between" class="ma-0 px-2">
  <v-btn variant="text" class="drawer-btn-links px-2" href="https://www.instagram.com/gpartnersco/" target="_blank">
    INSTAGRAM
  </v-btn>
  <v-btn variant="text" class="drawer-btn-links px-2" href="https://www.linkedin.com/company/gpartnersco/about/"
    target="_blank">
    Linkedin
  </v-btn>
  <v-btn variant="text" class="drawer-btn-links px-2" href="https://www.facebook.com/Gpartners.invest/" target="_blank">
    FACebook
  </v-btn>
  <v-btn variant="text" class="drawer-btn-links px-2" href="https://www.rabota.md/ru/companies/g-partners"
    target="_blank">
    Rabota.md
  </v-btn>
</v-row>
</v-list>
</v-navigation-drawer> -->
  <ContactUsModal ref="OpenContactUsModal" />

  <v-app-bar class="appBarHeader pt-2 pt-sm-4" :elevation="0" scroll-behavior="elevate" extended extension-height="0px">
    <v-container class="py-1 px-4" :fluid="$vuetify.display.mdAndDown ? true : false">
      <v-row justify="space-between">
        <v-col cols="6" sm="5" md="3" lg="3" xl="5" align-self="center">
          <svg @click="$router.push(GetPath('home'))" class="mt-3 img-logo-big" height="20px" max-width="100%"
            viewBox="0 0 290 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.5871 16.1092H22.2572C23.6762 16.1092 24.3856 16.7283 24.3856 17.9536L24.3462 25.202C23.571 25.9372 22.6776 26.5692 21.6791 27.098C20.6805 27.6268 19.6163 28.0395 18.4863 28.3233C17.3564 28.607 16.187 28.7618 14.9651 28.7618C12.6264 28.736 10.5768 28.1556 8.78987 27.0206C7.01613 25.8856 5.6234 24.2992 4.62485 22.2485C3.6263 20.1978 3.12705 17.8117 3.12705 15.0903C3.12705 12.3689 3.6263 9.96991 4.62485 7.93208C5.6234 5.88135 7.01613 4.29493 8.78987 3.14703C10.5636 1.99914 12.6264 1.43164 14.9651 1.43164C16.8045 1.43164 18.4338 1.71539 19.879 2.28289C21.3243 2.86329 22.5331 3.68874 23.4791 4.75924C24.4382 5.82975 25.1214 7.17112 25.5419 8.74463H25.9229L25.0952 2.97938C24.2937 2.46347 23.3871 1.98625 22.4017 1.56063C21.4163 1.135 20.3126 0.799665 19.0907 0.55461C17.8688 0.309554 16.4892 0.180586 14.9651 0.180586C12.022 0.180586 9.42052 0.799658 7.17378 2.03783C4.92705 3.27601 3.16647 5.0172 1.90515 7.26139C0.643818 9.49269 0.0131517 12.1109 0.0131517 15.0774C0.0131517 18.0438 0.643818 20.6492 1.90515 22.8676C3.16647 25.086 4.92705 26.8272 7.17378 28.0653C9.42052 29.3035 12.022 29.9355 14.9651 29.9742C17.0804 29.9742 18.9199 29.7033 20.4834 29.1745C22.0469 28.6457 23.374 27.9621 24.4645 27.1496C25.5419 26.337 26.409 25.5116 27.0528 24.699V17.9407C27.0003 16.7154 27.6966 16.0963 29.1419 16.0963H29.7726V15.6836H21.6002V16.0963L21.5871 16.1092Z"
              fill="#E6E8EB" />
            <path
              d="M78.925 22.7773L76.4811 29.4067H56.1291C54.8547 29.4067 53.7116 29.1874 52.805 28.8263C51.859 28.4264 51.0838 27.9621 50.4269 27.3946C49.8094 26.8529 49.2575 26.3112 48.8239 25.7824C48.7451 25.6792 48.4955 25.3826 48.1276 24.8538C47.7597 24.3508 47.3261 23.7059 46.8137 22.9836C46.3013 22.2614 45.7889 21.552 45.2764 20.8297C44.764 20.1075 44.3699 19.54 44.002 18.9983C43.6341 18.4952 43.4239 18.2115 43.3844 18.1341C42.8326 17.4505 42.2545 16.8056 41.637 16.2639C40.9801 15.6577 40.2837 15.3998 39.5479 15.3998V14.9742C40.3888 15.0129 41.1246 15.0129 41.7421 14.9742C42.4779 14.9355 43.2399 14.8323 44.1202 14.6517C45.0005 14.4712 45.802 14.0713 46.5378 13.4651C47.2998 12.859 47.8517 11.9561 48.259 10.705C48.3378 10.4213 48.4035 10.0602 48.4823 9.59585C48.5217 9.17022 48.5611 8.69301 48.5217 8.26739C48.4823 6.39723 48.0093 4.9269 47.0633 3.8177C46.1568 2.7085 44.9086 2.1281 43.3319 2.06361C42.5699 1.98623 41.7552 1.98623 40.9538 1.98623H38.1815V26.3757C38.1815 27.098 38.4311 27.7042 38.9829 28.2072C39.4953 28.7102 40.1129 28.9553 40.8487 28.9553H41.3611V29.3809H32.2559V28.9553H32.8077C33.5435 28.9553 34.1216 28.7102 34.6734 28.2072C35.1858 27.7042 35.4355 27.098 35.4749 26.3757V3.70162C35.4355 3.01805 35.1858 2.41186 34.6734 1.90885C34.1216 1.40584 33.5435 1.12209 32.8077 1.12209H32.2559V0.722266H43.5158C44.764 0.722266 45.894 0.902831 46.9188 1.26397C47.9436 1.6251 48.7845 2.12811 49.4809 2.81168C50.1772 3.45656 50.7291 4.28202 51.0838 5.21065C51.4517 6.13928 51.6356 7.22268 51.6356 8.43506C51.6356 9.72483 51.3466 10.9759 50.729 12.1625C50.1115 13.3878 49.2312 14.3551 48.167 15.1032C47.1028 15.8512 45.894 16.251 44.5538 16.251C45.0268 16.4316 45.5392 16.8185 46.1305 17.3989C46.6823 17.9793 47.1553 18.5468 47.5889 19.0885C48.3247 20.159 48.9816 21.0619 49.5597 21.8486C50.1115 22.5967 50.6896 23.3577 51.2809 24.067C51.8721 24.8151 52.3714 25.3955 52.7787 25.8598C53.3305 26.4273 53.9087 26.969 54.4605 27.4333C55.0123 27.8976 55.6298 28.2588 56.2474 28.5425C56.9043 28.7876 57.6007 28.9423 58.4022 28.9423H59.7949C60.5306 28.9423 61.1481 28.6973 61.6606 28.1943C62.173 27.6913 62.4226 27.0851 62.462 26.3628V3.68871C62.462 3.00514 62.2124 2.39895 61.6606 1.89594C61.1481 1.39293 60.5306 1.10918 59.7949 1.10918H59.2824L59.243 0.709356H71.3439C71.9614 0.709356 72.592 0.67066 73.2753 0.606172C73.9716 0.502991 74.5892 0.425623 75.1804 0.322442C75.7585 0.21926 76.1658 0.103181 76.4155 0V5.13327H76.0082V4.411C76.0082 3.72742 75.7454 3.18571 75.2724 2.6827C74.8651 2.25707 74.3264 2.03782 73.6957 1.96043H65.1423V14.6259H72.1979C72.7497 14.5873 73.2227 14.3809 73.6169 13.9811C73.9848 13.5812 74.195 13.1169 74.195 12.5881V12.0206H74.6023V18.4823H74.195V17.8761C74.195 17.3344 73.9716 16.8701 73.6169 16.4832C73.2096 16.0834 72.7366 15.877 72.1979 15.877H65.1423V28.104H71.0942C72.5526 28.104 73.7614 27.8847 74.7074 27.4204C75.6271 26.9948 76.3892 26.3499 76.9673 25.5245C77.5454 24.7377 78.0578 23.8091 78.5045 22.7644H78.9381L78.925 22.7773Z"
              fill="#E6E8EB" />
            <path
              d="M99.7893 25.5632C99.2112 26.3757 98.4491 27.0077 97.5162 27.4591C96.5834 27.9106 95.3878 28.1298 93.9031 28.1298H87.938V15.8899H94.9805C95.5323 15.8899 96.0053 16.0834 96.3994 16.4832C96.7936 16.8831 96.9775 17.3474 96.9775 17.902V18.5082H97.398V12.0464H96.9775V12.6139C96.9775 13.1685 96.7805 13.6328 96.3994 14.0327C96.0053 14.4325 95.5323 14.6389 94.9805 14.6647H87.938V2.01205H96.5046C97.109 2.07654 97.6476 2.2958 98.0681 2.73432C98.5411 3.21153 98.7776 3.77902 98.7776 4.4368V5.17198H99.198V0.0129103C98.9484 0.116092 98.5279 0.232171 97.9498 0.335352C97.3717 0.438533 96.741 0.541716 96.0578 0.619102C95.3746 0.696488 94.7308 0.748067 94.1133 0.748067H82.0256L82.065 1.1608H82.5643C83.2869 1.1608 83.9044 1.41875 84.4431 1.92176C84.9687 2.42477 85.2314 3.03096 85.2314 3.74033V26.4144C85.2052 27.1238 84.9293 27.73 84.4168 28.233C83.9044 28.736 83.2869 28.994 82.5643 28.994H82.0256V29.4067H99.3294L101.747 22.7773H101.326C100.88 23.8091 100.367 24.7377 99.7893 25.5632Z"
              fill="#E6E8EB" />
            <path
              d="M135.172 0.760977V1.1608H134.437C133.74 1.1608 133.162 1.40585 132.65 1.88307C132.137 2.38608 131.888 2.96647 131.848 3.67584V24.7635C131.848 25.6277 131.888 26.4531 131.953 27.2786C131.993 28.0653 132.098 28.9682 132.203 30H131.835L109.065 6.17799L109.105 26.5176C109.105 27.2012 109.354 27.7687 109.867 28.2717C110.379 28.736 110.957 28.994 111.654 28.994H112.455V29.4196H103.862V28.994H104.625C105.321 28.994 105.938 28.7489 106.411 28.2717C106.924 27.7687 107.173 27.2012 107.173 26.5176V5.27516C107.173 3.88221 107.068 2.19262 106.806 0.180586H107.239L129.93 23.9252V3.66295C129.89 2.94068 129.641 2.37319 129.168 1.87018C128.655 1.40586 128.077 1.14791 127.342 1.14791H126.54V0.748067H135.133L135.172 0.760977Z"
              fill="#E6E8EB" />
            <path
              d="M179.095 0.760997V1.16082H178.767C178.11 1.16082 177.414 1.38008 176.678 1.76701C175.916 2.16684 175.403 2.81173 175.101 3.66297L168.164 25.3697C167.875 26.3371 167.651 27.1625 167.507 27.8848C167.362 28.5684 167.257 29.2519 167.257 29.8968H166.85L158.336 6.53915L152.016 25.3697C151.767 26.2984 151.543 27.1238 151.399 27.8461C151.254 28.5297 151.175 29.2132 151.149 29.8839H150.781L141.347 3.70166H141.308C140.98 2.81172 140.428 2.15394 139.705 1.76701C138.969 1.36719 138.286 1.16082 137.655 1.16082H137.327V0.760997H146.577V1.16082H146.209C145.657 1.16082 145.184 1.40588 144.79 1.8444C144.566 2.08945 144.461 2.41189 144.461 2.77303C144.461 3.05678 144.501 3.34053 144.606 3.70166L150.926 23.6157L158.638 0.193496H159.045L167.27 22.7902L172.868 3.70166C173.091 2.87621 173.012 2.27003 172.644 1.83151C172.276 1.40588 171.803 1.14793 171.251 1.14793H170.884V0.748087H179.108L179.095 0.760997Z"
              fill="#E6E8EB" />
            <path
              d="M201.247 2.05076C199.001 0.812588 196.386 0.193496 193.404 0.193496C190.421 0.193496 187.859 0.812588 185.612 2.05076C183.365 3.28894 181.605 5.03013 180.344 7.27432C179.082 9.50562 178.452 12.1238 178.452 15.0903C178.452 18.0568 179.082 20.675 180.344 22.9063C181.605 25.1376 183.365 26.8788 185.612 28.1298C187.859 29.368 190.46 30 193.404 30C196.347 30 198.987 29.3809 201.247 28.1298C203.494 26.8917 205.255 25.1505 206.516 22.9063C207.777 20.675 208.408 18.0697 208.408 15.0903C208.408 12.1109 207.777 9.50562 206.516 7.27432C205.255 5.04303 203.494 3.30184 201.247 2.05076ZM203.731 22.2485C202.745 24.2992 201.366 25.8985 199.605 27.0335C197.844 28.1814 195.782 28.7489 193.417 28.7489C191.052 28.7489 189.028 28.1814 187.268 27.0335C185.507 25.8856 184.127 24.2863 183.142 22.2485C182.157 20.1978 181.657 17.8117 181.657 15.0903C181.657 12.3689 182.157 9.96993 183.142 7.9321C184.127 5.88137 185.507 4.29495 187.268 3.14705C189.028 1.99916 191.078 1.43166 193.417 1.43166C195.755 1.43166 197.844 1.99916 199.605 3.14705C201.366 4.29495 202.745 5.89426 203.731 7.9321C204.716 9.96993 205.215 12.3689 205.215 15.0903C205.215 17.8117 204.716 20.1978 203.731 22.2485Z"
              fill="#E6E8EB" />
            <path
              d="M258.007 22.7644L255.589 29.3938H235.198C233.924 29.3938 232.78 29.1745 231.874 28.8134C230.967 28.4136 230.153 27.9492 229.535 27.3817C228.878 26.84 228.326 26.2983 227.893 25.7695C227.827 25.6663 227.564 25.3439 227.196 24.8409C226.829 24.2992 226.395 23.693 225.883 22.9707C225.37 22.2485 224.858 21.5391 224.345 20.8168C223.833 20.0946 223.426 19.4884 223.071 18.9853C222.703 18.4823 222.493 18.1986 222.453 18.1212C221.901 17.4376 221.323 16.7927 220.693 16.2252C220.036 15.6448 219.339 15.3611 218.617 15.3611V14.9613C219.458 15 220.193 15 220.811 14.9613C221.547 14.9226 222.348 14.8194 223.189 14.6388C224.069 14.4583 224.871 14.0326 225.607 13.4523C226.369 12.8461 226.921 11.9432 227.328 10.6922C227.407 10.4084 227.472 10.0086 227.551 9.58296C227.591 9.11864 227.63 8.68012 227.591 8.2545C227.551 6.38434 227.078 4.91401 226.158 3.80481C225.212 2.69561 223.964 2.11521 222.401 2.05072C221.639 1.97334 220.824 1.94755 220.023 1.97334H217.25V26.3628C217.25 27.0851 217.513 27.6913 218.052 28.1943C218.564 28.6973 219.182 28.9423 219.918 28.9423H220.43V29.368H211.325V28.9423H211.877C212.612 28.9423 213.23 28.6973 213.742 28.1943C214.255 27.6913 214.504 27.0851 214.544 26.3628V3.68871C214.504 2.96644 214.255 2.39895 213.742 1.89594C213.23 1.35424 212.612 1.10918 211.877 1.10918H211.325V0.709356H222.585C223.833 0.709356 224.963 0.889921 225.988 1.25106C227.013 1.61219 227.853 2.11521 228.55 2.79879C229.246 3.44367 229.798 4.26913 230.153 5.19776C230.521 6.12639 230.705 7.20979 230.705 8.39637C230.705 9.72483 230.415 10.9759 229.798 12.1625C229.18 13.3878 228.3 14.3551 227.236 15.1032C226.172 15.8512 224.963 16.2124 223.649 16.2124C224.083 16.4316 224.634 16.8185 225.186 17.3989C225.738 17.9664 226.211 18.5468 226.645 19.0885C227.38 20.159 228.037 21.0619 228.615 21.8486C229.167 22.5967 229.745 23.3577 230.337 24.067C230.928 24.8151 231.427 25.3955 231.834 25.8211C232.386 26.4273 232.964 26.969 233.516 27.4333C234.068 27.8976 234.686 28.2588 235.342 28.5425C235.934 28.7876 236.656 28.9423 237.432 28.9423H238.851C239.586 28.9423 240.204 28.6973 240.716 28.1943C241.229 27.6913 241.478 27.0851 241.518 26.3628V3.68871C241.478 2.96644 241.229 2.39895 240.716 1.89594C240.204 1.35424 239.586 1.10918 238.851 1.10918H238.299V0.709356H247.43V1.10918H246.878C246.182 1.10918 245.565 1.35424 245.052 1.89594C244.54 2.39895 244.251 2.96644 244.211 3.68871V28.0782H250.202C251.661 28.0782 252.87 27.8589 253.789 27.3946C254.735 26.969 255.471 26.3241 256.049 25.4987C256.627 24.6732 257.14 23.7704 257.626 22.7386H258.033L258.007 22.7644Z"
              fill="#E6E8EB" />
            <path
              d="M288.095 7.55797C286.834 5.40406 285.073 3.72737 282.839 2.54078C280.606 1.3542 278.004 0.760918 275.022 0.760918H260.884L260.924 1.17363H261.423C262.146 1.17363 262.763 1.4316 263.302 1.93461C263.828 2.43762 264.09 3.04379 264.09 3.75317V26.4273C264.064 27.1366 263.788 27.7428 263.276 28.2458C262.763 28.7488 262.146 29.0068 261.423 29.0068H260.884V29.4195H275.022C277.991 29.4195 280.606 28.8133 282.839 27.6138C285.073 26.4144 286.834 24.7506 288.095 22.5967C289.356 20.4556 289.987 17.9535 289.987 15.0902C289.987 12.2269 289.356 9.71188 288.095 7.55797ZM285.388 21.9647C284.403 23.9251 283.023 25.4599 281.263 26.5433C279.502 27.6396 277.426 28.1813 275.035 28.1813H266.823V1.98619H275.035C277.4 1.98619 279.463 2.5279 281.25 3.6242C283.023 4.7205 284.416 6.24241 285.401 8.20286C286.387 10.1633 286.886 12.4591 286.886 15.0773C286.886 17.6955 286.387 19.9913 285.401 21.9518"
              fill="#E6E8EB" />
          </svg>
        </v-col>
        <v-col cols="auto" align-self="center">
          <div class="appbarBtns py-2 px-3">
            <v-btn variant="flat" icon="" @click="ChangeLang()" color="#101010"
              class="btn-appbar-lang px-0 fontSFProR mr-2">
              {{ $vuetify.locale.current.toUpperCase() }}
            </v-btn>
            <v-btn variant="flat" @click="OpenModal()" color="#101010" class="px-5 btn-appbar fontSFProR mr-2"
              size="large" v-if="$vuetify.display.smAndUp">
              {{ t(`$vuetify.home.header.btn_get_in_touch`) }}
              <template v-slot:append>
                <svg width="11" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11 0.971933V9.15211C11 9.27727 10.9503 9.39731 10.8618 9.48581C10.7733 9.57432 10.6532 9.62404 10.5281 9.62404C10.4029 9.62404 10.2829 9.57432 10.1944 9.48581C10.1059 9.39731 10.0561 9.27727 10.0561 9.15211V2.11087L0.79366 11.3733C0.704197 11.4567 0.585871 11.5021 0.463608 11.4999C0.341345 11.4978 0.224692 11.4482 0.138226 11.3618C0.0517596 11.2753 0.00223071 11.1587 7.35255e-05 11.0364C-0.00208366 10.9141 0.0432993 10.7958 0.126662 10.7063L9.38913 1.44387H2.34789C2.22273 1.44387 2.10269 1.39414 2.01419 1.30564C1.92568 1.21714 1.87596 1.0971 1.87596 0.971933C1.87596 0.846769 1.92568 0.726731 2.01419 0.638226C2.10269 0.549721 2.22273 0.5 2.34789 0.5H10.5281C10.6532 0.5 10.7733 0.549721 10.8618 0.638226C10.9503 0.726731 11 0.846769 11 0.971933Z"
                    fill="#E6E8EB" />
                </svg>
              </template>
            </v-btn>
            <v-btn icon="mdi-menu" variant="flat" class="btn-appbar fontSFProR px-3" color="#101010"
              @click.stop="drawer = !drawer">
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
  <div id="div_scale_dark" class=""></div>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "./Modals/ContactUsModal.vue";

export default {
  name: "HeaderComponent",
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  data: () => ({
    drawer: null,
  }),
  components: {
    ContactUsModal
  },
  methods: {
    OpenModal() {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
    ChangeLang() {
      let div = document.getElementById("div_scale_dark");
      div.style.display = 'block';
      div.classList.add('div_scale_dark_class_anim');
      div.addEventListener('animationend', function () {
        div.style.display = 'none';
        div.classList.remove('div_scale_dark_class_anim');
      }, { once: true });

      window.setTimeout(() => {
        window.scrollTo(0, 0);
        let lang = this.$vuetify.locale.current == "en" ? "de" : "en";
        this.$vuetify.locale.current = lang;
        localStorage.setItem("language", lang.toLowerCase());
        this.$router.push({ params: { lang: lang } })
      }, 650);
    },
    GetPath(name) {
      if (this.$route.name == "home") {
        window.scrollTo(0, 0);
      }
      switch (name) {
        case "home":
          return {
            name: 'home',
            params: { lang: this.$vuetify.locale.current }
          };
        default:
          return {
            name: 'home',
            params: { lang: this.$vuetify.locale.current }
          };
      }
    },
    changeLocale(lang) {
      this.drawer = false;
      this.$vuetify.locale.current = lang;
      localStorage.setItem("language", lang.toLowerCase());
      this.$router.push({ params: { lang: lang } })
    },
  },
};
</script>
<style scoped>
#div_scale_dark {
  width: 0px;
  height: 0px;
  position: fixed;
  border-radius: 100%;
  top: 0%;
  right: 10%;
  background: #000;
  z-index: 999;
  display: none;
}

.div_scale_dark_class_anim {
  animation: scale_dark_animation 1.3s ease-in-out 0s normal forwards;
}


@keyframes scale_dark_animation {
  0% {
    width: 0px;
    height: 0px;
    scale: 1;
    opacity: 1;
  }

  50% {
    width: 100vw;
    height: 100vw;
    scale: 3;
    opacity: 1;
  }

  100% {
    width: 100vw;
    height: 100vw;
    scale: 3;
    opacity: 0;
  }
}

.drawer-btn-links {
  color: #c4c4c4;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.005rem;
}

.drawer-item-consult {
  background: rgba(47, 47, 47, 0.43);
  font-size: 20px;
  color: #9a9a9b;
  text-transform: inherit;
  border-radius: 9px;
  font-weight: 400;
  letter-spacing: -0.01rem;
}

.drawer-list-items {
  color: #f6f2e6;
  font-size: 40px;
  line-height: 50px;
  font-weight: 400;
  letter-spacing: -0.01rem;
}

.drawer-langs {
  min-width: 50px;
  background: rgba(47, 47, 47, 0.43);
  border-radius: 9px;
  font-size: 19px;
  font-weight: 400;
  letter-spacing: -0.008rem;
}

.subheader {
  color: #373737;
  font-size: 12px;
  text-transform: uppercase;
  min-height: 25px;
}

.btn-close-drawer {
  /* animation-name: Btn_close_drawer_anim;
  animation-duration: 1.1s;
  animation-direction: normal;
  animation-timing-function: linear;
  animation-fill-mode: forwards; */
  /* animation: Btn_close_drawer_anim 1.1s ease-in-out 0s normal forwards;
  -o-animation: Btn_close_drawer_anim 1.1s ease-in-out 0s normal forwards;
  -ms-animation: Btn_close_drawer_anim 1.1s ease-in-out 0s normal forwards;
  -moz-animation: Btn_close_drawer_anim 1.1s ease-in-out 0s normal forwards;
  -webkit-animation: Btn_close_drawer_anim 1.1s ease-in-out 0s normal forwards;
  transform: rotate(-360deg) scale(0.4); */
}

/* @keyframes Btn_close_drawer_anim {
  from {
    transform: rotate(-360deg) scale(0.4);
  }

  to {
    transform: rotate(0deg) scale(1);
  }
} */

.appBarHeader {
  max-height: 100px;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
}

.btn-appbar-lang {
  text-transform: inherit;
  color: #EEAC47 !important;
  font-weight: 400;
  border-radius: 30px;
  min-height: 48px;
  letter-spacing: 0px;
}

.btn-appbar {
  text-transform: inherit;
  color: #E6E8EB;
  font-weight: 400;
  border-radius: 30px;
  min-height: 48px;
  letter-spacing: 0px;
}

.img-logo {
  margin-right: auto;
  transition: .3s;
}

.img-logo:hover {
  cursor: pointer;
  filter: brightness(4);
}

.img-logo-big {
  transition: .3s;
}

.img-logo-big:hover {
  filter: brightness(4);
  cursor: pointer;
}

@media screen and (min-width: 600px) {
  .appbarBtns {
    background: rgba(0, 0, 0, 0.13);
    border-radius: 25px;
    display: flex;
    justify-content: space-between;
    backdrop-filter: blur(7px);
    align-items: center;
  }
}

@media screen and (max-width: 600px) {
  .appBarHeader {
    background: linear-gradient(rgba(17, 18, 19, 1), rgba(0, 0, 0, 0));
  }
}
</style>